import { AzureServicesPage } from "./azure/AzureServices";

export const WebsitesAzurePage = AzureServicesPage;
